export enum ExperimentActions {
  setExperiment = 'setExperiment',
}

export interface IExperimentAction {
  type: ExperimentActions;
  payload: { [key: string]: string };
}

export type IExperimentsDispatch = (action: ExperimentActions) => void;

export interface IExperimentState {
  [key: string]: string;
}

export const experimentsReducer = (state: IExperimentState, action: IExperimentAction) => {
  switch (action.type) {
    case ExperimentActions.setExperiment:
      state[action?.payload?.experimentName] = action?.payload?.groupAssigned;
      break;

    default:
      return state;
  }
  return state;
};
